import { State } from '../State';
import { SyncActionAPI } from '../config/actions/createActions';

export function endVisitAction(
  deleteVisitSession: () => void,
  state: State,
  api: Pick<SyncActionAPI, 'postMessage' | 'scheduledActions'>,
  sendMessage: boolean = true,
) {
  // No active session. Bail.
  const visitSession = state.visit.visitSession;
  if (!visitSession) {
    throw new Error('No active visit session');
  }

  // Get data from active session.
  const { friendId, attributeDebuffs } = visitSession;

  if (attributeDebuffs?.love || attributeDebuffs?.stomach) {
    api.postMessage.applyVisitDebuff(friendId, attributeDebuffs);
  }

  // Schedule an action to send analytics and chatbot messages.
  api.scheduledActions.schedule.endVisit({
    args: { visitSession, sendMessage },
    notificationId: `endVisit-${friendId}`,
    delayInMS: 0,
  });

  // Delete the session.
  deleteVisitSession();
}
